/* global System */
// register component(s) with react habitat

export default { NewReactVC: () => System.import('./Component') }
